/**
 Author - Babajan
Github - https://github.com/babajanpatan
 **/

import React from "react";
import PropTypes from "prop-types";
import styled, {keyframes} from "styled-components";

import SafeLink from "components/commons/SafeLink";
import parseHtmlContent from "helpers/parseHtmlContent";


import {
  WealthyEnv
} from "helpers";

const benefitItems = [
  {
    icon: "https://i.wlycdn.com/articles/e-book-thank-you.png",
    text: "Level up your Sales skills by downloading our <span>Free E-Book!<span>",
    action: "Download",
    actionLink: "https://i.wlycdn.com/articles/Equity_Brochure_Updated.pdf",
    id: "e-book-download-thankyou-page-onboarding"
  },
  {
    icon: "https://i.wlycdn.com/articles/business-pdf.png",
    text: "Unlock the full potential of your Wealth Practice by downloading this  <span>Business PDF</span>",
    action: "Download",
    actionLink: "https://i.wlycdn.com/wealth-partners/Business_Brochure_Updated.pdf",
    id: "business-pdf-download-thankyou-page-onboarding"
  },
  {
    icon: "https://i.wlycdn.com/articles/reading-materials.png",
    text: "Get smarter about stocks and the economy with our <span>insightful videos and newsletters</span>",
    action: "Explore",
    actionLink: `${WealthyEnv.URL}/newsletter/bulls-eye?utm_campaign=Thank-You-Page-Click`,
    id: "reading-materials-download-thankyou-page-onboarding"
  }
];

const heroThankyou  = `${WealthyEnv.CDN_URL}/articles/thank-you-page-new-hero.svg`;
const crossIcon = `${WealthyEnv.CDN_URL}/articles/close-svg.svg`;
const appStoreThankyou = `${WealthyEnv.CDN_URL}/articles/app-store-thank-you-page.svg`;
const palyStoreThankyou = `${WealthyEnv.CDN_URL}/articles/playstore-thank-you-page.svg`;
const wealthyPartnerPlayStoreQR = `${WealthyEnv.CDN_URL}/articles/play-store-qr-one.svg`;
const wealthyPartnerAppStoreQR = "https://i.wlycdn.com/articles/app-store-qr-one.svg";

const youtubeVideo = "https://www.youtube-nocookie.com/embed/_MkmDrNg62Q";


const propTypes = {
  handleClose: PropTypes.func.isRequired
};

const NewThankYou = ({
  handleClose,
  scrollToBottom,
  bottomRef
}) => {
  return (
    <Section>
      <CloseContainer>
        <img
          alt="thankyou-image"
          className="thankyou-image"
          src={crossIcon}
          onClick={handleClose}
        />
      </CloseContainer>
      <Wrapper>
        <Image>
          <img  alt="thankyou-image" className="thankyou-image" src={heroThankyou} />
        </Image>
        <Title>Thank you for signing up with <Strong>Wealthy!</Strong></Title>
        <Subheader>Our team will be in touch with you soon.
        </Subheader>
      </Wrapper>
      <WrapperVideo>
        <Title style={{margin: "0 0", fontSize: "2.4rem"}}>
          Watch what our Wealth Partners have to say about us
        </Title>
        <Subheader>(Just a 1 minute video)
        </Subheader>
        <VideoContainer>
          <iframe
            allowFullScreen
            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            src={youtubeVideo}
            title="Wealthy Partners Video"
            style={{ width: "500px" }}
          />
          <StyledArrow onClick={scrollToBottom}>
            <p>
             Download <br />
           Free Content
            </p>
            <img
              alt="Scroll down arrow"
              src="https://i.wlycdn.com/articles/arrow-thankyou-page.svg"
            />
          </StyledArrow>

        </VideoContainer>
        <Title style={{margin: "1rem 0", fontSize: "2.4rem"}}>
         And we’ve got more for you as you wait ..
        </Title>
      </WrapperVideo>
      <BenefitsWrapper ref={bottomRef}>
        {benefitItems.map((item, index) => (
          <div 
            key={index}
          >
            <BenefitItem>
              <BenefitIcon>
                <img
                  alt="Benefit Icon"
                  src={item.icon}
                />
              </BenefitIcon>
              <BenefitText>{parseHtmlContent(item.text)}</BenefitText>
              <BenefitActionButton
                id={item.id}
                role="button"
                href={item.actionLink}
                rel="noopener noreferrer"
                target="_blank"
              >{item.action}</BenefitActionButton>
            </BenefitItem>
            {index < benefitItems.length - 1 && <Hr />}
          </div>
        ))}
      </BenefitsWrapper>
      <DownloadAppSection>
        <DownloadAppDetails>
          <DownloadAppContent>
            <Title style={{margin: "0.5rem 0", fontSize: "1.8rem", fontWeight: 500}}>
        Download
            </Title>
            <Title style={{margin: "0.5rem 0", fontSize: "2.4rem", fontWeight: 700}}>
     Wealthy Partner App
            </Title>
            <Subheader  style={{margin: "0.5rem 0", fontSize: "1.4rem", textAlign: "left", fontWeight: 400}}>
        Deliver exceptional investing <br />
experience to your clients.
            </Subheader>
          </DownloadAppContent>
          <DownloadApps>
            <DownloadAppsAndQRs>
              <DownloadLinks
                href={WealthyEnv.PARTNER_APP_NEW_PLAYSTORE_LINK}
                rel="noopener noreferrer"
                target="_blank"
              >
                <img
                  alt="playstore"
                  src={palyStoreThankyou}
                />
              </DownloadLinks>
              <DownloadQRs>
                <img
                  alt="playstore-qr"
                  src={wealthyPartnerPlayStoreQR}
                />
              </DownloadQRs>
            </DownloadAppsAndQRs>
            <DownloadAppsAndQRs>
              <DownloadLinks
                href={WealthyEnv.PARTNER_APP_NEW_APPSTORE_LINK}
                rel="noopener noreferrer"
                target="_blank"
              >
                <img
                  alt="appstore"
                  src={appStoreThankyou}
                />
              </DownloadLinks>
              <DownloadQRs>
                <img
                  alt="appstore-qr"
                  src={wealthyPartnerAppStoreQR}
                />
              </DownloadQRs>
            </DownloadAppsAndQRs>
          </DownloadApps>
        </DownloadAppDetails>
      </DownloadAppSection>
    </Section>
  );
};

const Section = styled.div`
  background-color: white;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #6725F4;

    border-radius: 4px;
  }
`;


const CloseContainer = styled.div`
    display: flex;
    justify-content: end;
    align-items: center;
    background-color:rgba(246, 242, 255, 1);

    img {
      padding: 2rem;
      padding-right: 3rem;
      cursor: pointer;
      padding-bottom: 0.5rem;
    }
`;


const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background-color:rgba(246, 242, 255, 1);
  padding-top: 0rem;
`;

const WrapperVideo = styled(Wrapper)`
    background-color:#fff;
    margin-top: 1rem;
`;

const Title = styled.h3`
  margin: 2rem 0 0.8rem 0;
  font-family:'Lato' ;
  font-size: 3rem;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #1c1c1c;

  @media(max-width: 768px) {
    font-size: 2.4rem;
  }
`;


const Strong = styled.span`
  color: #6725F4;
`;


const Subheader = styled(Title)`
  font-size: 2.4rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: center;
  color: #7E7E7E;
  margin-top: 1rem;


  @media(max-width: 768px) {
    font-size: 1.8rem;
  }
`;

const Image = styled.div`
  img {
    width: 100px;
    height: 100px;
  }
`;

const VideoContainer  = styled.div`
    padding-bottom: 4rem;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    iframe {
    width: 500px;
    height: 315px;
    border: none;
    border-radius: 10px;
  }
`;

const BenefitsWrapper = styled.div`
   border: 1px solid #DDDDDD;
   border-radius: 10px;
   margin: 2rem 4rem;
   padding: 2rem;
   display: flex;
   justify-content: center;
   align-items: center;
   flex-direction: column;

   @media (max-width:768px){
    margin: 2rem 2rem;
   }
`;

const BenefitItem = styled.div`
   display: flex;
   justify-content: center;
   align-items: center;
   width: 100%;
   gap: 2.5rem;
   padding: 3rem 0rem;

   @media (max-width:768px){
     padding: 1rem 0rem;
     gap: 1rem;
   }
`;

const BenefitText = styled.div`
   width: 380px;
   font-size: 2rem;
   font-family:'Lato' ;
   font-stretch: normal;
   line-height: 1.2;
   font-style: normal;
   letter-spacing: normal;
   text-align: start;
   font-weight: 400 !important;
   color: black;

   span {
    font-weight: 700 !important;
    font-family: "Lato-Bold" !important;
   }

   @media (max-width:768px){
      font-size: 1.4rem;
      width: 100%;
   }
`;

const BenefitIcon = styled.div`
  width: 64px;
  height: 64px;

  img {
    width: 100%;
    height: 100%;
  }

  @media (max-width:768px){
     width: 30px;
     height: 30px;
  }
`;

const BenefitActionButton = styled(SafeLink)`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #6725f4;
  padding:0.5rem;
  background-color: #fff;
  color: #6725f4;
   font-size: 2rem;
  font-family:'Lato' ;
  border-radius: 20px;
  cursor: pointer;
  width: 130px;

  @media (max-width:768px){
     width: 50%;
     font-size: 1.4rem;
  }
`;

const Hr = styled.div`
  height: 1px;
  width: 100%;
  border-bottom: 1px solid #DDDD;

  @media (max-width:768px){
      width: 100%;
      margin: 0 1rem;
  }
`;

const DownloadAppSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 2rem 4rem;
  box-shadow: 0px 4px 18.3px 0px #00000017;
  border-radius: 10px;
  padding: 2rem 2rem;

  @media (max-width:768px){
    margin: 2rem 2rem;
    padding: 2rem 2rem;
    justify-content: center;
    align-items: start;
  }
`;

const DownloadAppDetails = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;

  @media (max-width:768px){
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 2rem;
  }
`;

const DownloadAppContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
`;



const DownloadApps = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4rem;

  @media (max-width:768px){
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
`;

const DownloadAppsAndQRs = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 1rem;
  width: 100%;
`;

const DownloadLinks = styled(SafeLink)`
   display: flex;
   justify-content: center;
   align-items: center;
   gap: 1rem;

    img {
    cursor: pointer;
    width: 100%;
  }
`;

const DownloadQRs = styled.div`
   display: flex;
   justify-content: center;
   align-items: center;
   width: 70px;

   img {
    width: 100%;
  }

  @media (max-width:768px){
    width: 30%;
  }
`;
const bounce = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
`;


const StyledArrow = styled.div`
  position: absolute;
  bottom: 120px;
  left: 90%;
  transform: translateX(-50%);
  animation: ${bounce} 1.5s infinite;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  text-align: center;

  p{
      font-size: 1.4rem;
      text-align: center;
  }


  img {
    margin-top: 1rem;
    width: 80%;
    padding: 1rem 1.75rem;
    box-shadow: 0px 2px 34px 2px #95959540;
    background-color: #fff;
    border-radius: 50%;
  }

  @media (max-width:768px){
    display: none;
  }
`;
NewThankYou.propTypes = propTypes;

export default NewThankYou;
